import { useCurrentAnimal } from "components/Signup/store/selectors/animals";
import { SpeciesEnum } from "../../../__generated__/globalTypes";
import styles from "./BreedEmoji.module.css";

export const BreedEmoji = () => {
  const animal = useCurrentAnimal();

  return (
    <div className={styles.emoji}>
      {animal.species === SpeciesEnum.dog ? "🐕" : "🐱"}
    </div>
  );
};
